import { Box } from "@material-ui/core";
import { DashedDivider } from "Views/PurchaseOrder/Form/Views/Dividers";
import { FormSection } from "Views/PurchaseOrder/Form/Views/Forms";
import styled from "styled-components";
import { FormHeader } from "Views/PurchaseOrder/Form/Views/FormHeaders";
import { NonConformanceListModel } from "./NonConformanceListModel";

const HeaderContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-right: 70px;
    padding: 10px 0;

    // Header
    > div:nth-child(1) {
        margin: 0 30px;
        h1 {
            font: normal normal 600 28px/38px Open Sans;
            letter-spacing: -0.56px;
            color: #191919;
        }
    }
`;
const ProjectDetailsContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;

    > div {
        font: normal normal normal 12px/16px Segoe UI;
        letter-spacing: -0.18px;
        color: #191919;
    }

    > div > span {
        font-weight: bold;
        margin-right: 10px;
    }
`;
interface FormHeaderProps {
    ProjectDetails: any;
    NonConformanceListItems: NonConformanceListModel[];
    item?: any;
    FormHeaderTitle: string;
    ProjectDate: string;
    CompletedBy: string;
    SafetyId?: string | null;
    IsNewForm?: Boolean;
}

const NonConformanceFormHeader: React.FC<FormHeaderProps> = ({ ProjectDetails, FormHeaderTitle, ProjectDate, CompletedBy, SafetyId, NonConformanceListItems, IsNewForm, item }) => {
    const referenceNumber =
        IsNewForm && NonConformanceListItems.length > 0 ? Math.max(...NonConformanceListItems?.map((i) => parseInt(i.nonConformanceNumber))) : item?.nonConformanceNumber;
    const NonConformanceNumber = referenceNumber ? (IsNewForm ? referenceNumber + 1 : referenceNumber) : 1;
    let formattedNumber = NonConformanceNumber.toLocaleString("en-US", {
        minimumIntegerDigits: 8,
        useGrouping: false,
    });

    return (
        <>
            <DashedDivider gutterBottom={false} gutterTop={false} borderThickness={1} borderOpacity={0.5} />

            <HeaderContainer>
                <FormHeader displayName={`CDG-${formattedNumber} - ${FormHeaderTitle}`} />
            </HeaderContainer>

            <FormSection>
                <ProjectDetailsContainer>
                    {/* {SafetyId && (
                        <div>
                            <span>Date:</span> {ProjectDate}
                        </div>
                    )} */}
                    <div>
                        <span>Project reference:</span> {ProjectDetails?.projectReference}
                    </div>
                    <div>
                        <span>Project name:</span> {ProjectDetails?.projectName}
                    </div>
                    {/* {SafetyId && (
                        <div>
                            <span>Completed by:</span> {CompletedBy}
                        </div>
                    )} */}
                </ProjectDetailsContainer>
            </FormSection>
        </>
    );
};

export default NonConformanceFormHeader;
